module.exports = __webpack_public_path__ + "fonts/zent-bold.ef47588.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Zent/zent-bold.woff
// module id = 135
// module chunks = 245 246